import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../../../../../reducers/types";
import { getAirlinesMap } from "../../../../../../reducer";
import { ConfirmationModalContent } from "./component";

const mapStateToProps = (state: IStoreState) => ({
  airlineMap: getAirlinesMap(state),
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ConfirmationModalContentConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedConfirmationModalContent = connector(
  ConfirmationModalContent
);
